import script from "./ExamYamlExportView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamYamlExportView.vue?vue&type=script&setup=true&lang=js"

import "./ExamYamlExportView.vue?vue&type=style&index=0&id=47b9fbeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b9fbeb"]])

export default __exports__